// extracted by mini-css-extract-plugin
module.exports = {"item":"item__YH2dt","setByClient":"setByClient__jgFq0"};